import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { data, portal, type Command } from "@aawaz/api-client";
import { t } from "@aawaz/i18n";
import { Badge, Card, Empty, ErrorBanner, Modal, Spinner, Table, fmtDate } from "@aawaz/ui";

/** Screen 9: command history (read-only in v1, OPEN-Q26) with per-voucher / per-document results. */
export function ActivityPage() {
  const q = useQuery({ queryKey: ["commands"], queryFn: () => data<{ data: Command[] }>(portal.GET("/portal/v1/commands")) });
  const [open, setOpen] = useState<Command | null>(null);
  const vouchers = (open?.result?.vouchers as { remote_id: string; status: string; voucher_number?: string; line_error?: string }[] | undefined) ?? [];
  return (
    <>
      <h1>{t("nav.activity")}</h1>
      <ErrorBanner error={q.error} />
      <Card>
        {q.isLoading ? <Spinner /> : (q.data?.data.length ?? 0) === 0 ? <Empty>No commands yet.</Empty> : (
          <Table rows={q.data!.data} rowKey={(r) => r.id} onRowClick={setOpen} columns={[
            { key: "t", header: "Command", render: (r) => r.type },
            { key: "s", header: "Status", render: (r) => <Badge value={r.status} /> },
            { key: "e", header: "Error", render: (r) => r.error_code ?? "—" },
            { key: "b", header: "Approved by", render: (r) => String((r.approval?.approved_by as { display?: string; id?: string } | undefined)?.display
              ?? (r.approval?.approved_by as { id?: string } | undefined)?.id ?? "—") },
            { key: "d", header: "Created", render: (r) => fmtDate(r.created_at) },
          ]} />
        )}
      </Card>
      <Modal open={!!open} title={open?.type ?? ""} onClose={() => setOpen(null)}>
        {vouchers.length ? (
          <Table rows={vouchers} rowKey={(r) => r.remote_id} columns={[
            { key: "n", header: "Voucher", render: (r) => r.voucher_number ?? r.remote_id.slice(0, 8) },
            { key: "s", header: "Result", render: (r) => <Badge value={r.status} tone={r.status === "failed" ? "red" : "green"} /> },
            { key: "e", header: "Error", render: (r) => r.line_error ?? "—" },
          ]} />
        ) : <pre className="ui-mono">{JSON.stringify(open?.result, null, 2)}</pre>}
      </Modal>
    </>
  );
}
